import { render, staticRenderFns } from "./MoreAdvertisingOptions.vue?vue&type=template&id=7ef5fa1a&scoped=true&"
import script from "./MoreAdvertisingOptions.vue?vue&type=script&lang=js&"
export * from "./MoreAdvertisingOptions.vue?vue&type=script&lang=js&"
import style0 from "./MoreAdvertisingOptions.vue?vue&type=style&index=0&id=7ef5fa1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef5fa1a",
  null
  
)

export default component.exports